<div class="c-content c-content--wrapper u-no-p" [ngStyle]="vm.loading && {'min-height': '300px'}">
	<div *ngIf="!vm.loading">
		<div class="c-content u-no-ph@md-and-up u-hidden@up-to-md">
			<div class="o-grid">
				<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-25@lg-and-up u-no-p o-grid__cell--right">
					<form class="c-form">
						<div class="o-grid">
							<div class="o-grid__cell o-grid__cell--slim">
								<div class="c-form__group c-form__group--icon u-osb-sm">
									<i class="o-icon o-icon--search c-form__icon" aria-hidden="true"></i>
									<input id="joinRequestSearchInput" name="joinRequestSearchInput" type="text" class="c-form__input c-form__input--sm" placeholder="{{ 'Employees.Search_Placeholder' | translate }}" spellcheck="false" [(ngModel)]="vm.term" (ngModelChange)="onSearchChange($event)">
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
		<div class="c-content c-content--border-bottom u-no-ph@md-and-up u-hidden@up-to-md">
			<div class="o-grid o-grid--wrap">
				<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
					<a id="createdFilter" href="javascript:void(0)" class="c-text c-text--gray" (click)="vm.setFilter('created')" aria-hidden="true"><span style="vertical-align:middle">{{ 'Employees.Invited_Date' | translate }}</span>&nbsp;<span *ngIf="vm.filter.orderBy==='created' && vm.filter.ascending">&#8595;</span><span *ngIf="vm.filter.orderBy==='created' && !vm.filter.ascending">&#8593;</span></a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-20 u-no-p">
					<a id="nameFilter" href="javascript:void(0)" class="c-text c-text--gray" (click)="vm.setFilter('name')" aria-hidden="true"><span style="vertical-align:middle">{{ 'Employees.Name' | translate }}</span>&nbsp;<span *ngIf="vm.filter.orderBy==='name' && vm.filter.ascending">&#8595;</span><span *ngIf="vm.filter.orderBy==='name' && !vm.filter.ascending">&#8593;</span></a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-20 u-no-p">
					<a id="emailFilter" href="javascript:void(0)" class="c-text c-text--gray" (click)="vm.setFilter('email')" aria-hidden="true"><span style="vertical-align:middle">{{ 'Employees.Email' | translate }}</span>&nbsp;<span *ngIf="vm.filter.orderBy==='email' && vm.filter.ascending">&#8595;</span><span *ngIf="vm.filter.orderBy==='email' && !vm.filter.ascending">&#8593;</span></a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
					<a id="personalCodeFilter" href="javascript:void(0)" class="c-text c-text--gray" (click)="vm.setFilter('personalCode')" aria-hidden="true"><span style="vertical-align:middle">{{ 'Employees.Personal_Code' | translate }}</span>&nbsp;<span *ngIf="vm.filter.orderBy==='personalCode' && vm.filter.ascending">&#8595;</span><span *ngIf="vm.filter.orderBy==='personalCode' && !vm.filter.ascending">&#8593;</span></a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-10 u-no-p">
					<a id="statusFilter" href="javascript:void(0)" class="c-text c-text--gray c-text--right" (click)="vm.setFilter('status')" aria-hidden="true"><span style="vertical-align:middle">{{ 'Employees.Status' | translate }}</span>&nbsp;<span *ngIf="vm.filter.orderBy==='status' && vm.filter.ascending">&#8595;</span><span *ngIf="vm.filter.orderBy==='status' && !vm.filter.ascending">&#8593;</span></a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-20 u-no-p">
					<span>&nbsp;</span>
				</div>
			</div>
		</div>
		<ul class="c-list">
			<li id="joinRequestRow{{$index}}" *ngFor="let joinRequest of vm.joinRequests | startFrom:vm.currentPage*vm.pageSize | arrayLimitTo:vm.pageSize ; let $index=index">
				<div class="c-content c-content--border-bottom u-no-ph@md-and-up">
					<div class="o-grid o-grid--wrap@up-to-md">
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
							<div class="o-grid o-grid--center-v u-hidden@md-and-up">
								<div class="o-grid__cell u-no-p">
									<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'Employees.Invited_Date' | translate }}:</p>
								</div>
								<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
									<p class="c-text c-text--sm@up-to-md">
										{{ joinRequest.created | date:'dd.MM.yyyy' }} <span>{{ joinRequest.created | date:'HH:mm:ss' }}</span>
									</p>
								</div>
							</div>
							<p class="c-text c-text--s10 u-hidden@up-to-md">{{ joinRequest.created | date:'dd.MM.yyyy' }} <span class="u-hidden@up-to-lg">{{ joinRequest.created | date:'HH:mm:ss' }}</span></p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-20@md-and-up u-no-p">
							<div class="o-grid o-grid--center-v u-hidden@md-and-up">
								<div class="o-grid__cell u-no-p">
									<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'Employees.Name' | translate }}:</p>
								</div>
								<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
									<p class="c-text c-text--sm@up-to-md">
										{{ joinRequest.employee.firstname }} {{ joinRequest.employee.lastname }}
									</p>
								</div>
							</div>
							<p class="c-text u-hidden@up-to-md">{{ joinRequest.employee.firstname }} {{ joinRequest.employee.lastname }}</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-20@md-and-up u-no-p">
							<div class="o-grid o-grid--center-v u-hidden@md-and-up">
								<div class="o-grid__cell u-no-p">
									<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'Employees.Email' | translate }}:</p>
								</div>
								<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
									<p id="joinRequestEmailLabel" class="c-text c-text--sm@up-to-md">
										{{ joinRequest.employee.email }}
									</p>
								</div>
							</div>
							<p class="c-text c-text--s10 u-hidden@up-to-md">{{ joinRequest.employee.email }}</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
							<div class="o-grid o-grid--center-v u-hidden@md-and-up">
								<div class="o-grid__cell u-no-p">
									<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'Employees.Personal_Code' | translate }}:</p>
								</div>
								<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
									<p class="c-text c-text--sm@up-to-md">
										{{ joinRequest.employee.personalCode ? joinRequest.employee.personalCode : '-' }}
									</p>
								</div>
							</div>
							<p class="c-text c-text--s10 u-hidden@up-to-md">{{ joinRequest.employee.personalCode }}</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-10@md-and-up u-no-p">
							<div class="o-grid o-grid--center-v u-hidden@md-and-up">
								<div class="o-grid__cell u-no-p">
									<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'Employees.Status' | translate }}:</p>
								</div>
								<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
									<p id="joinRequestStatusLabel" class="c-text c-text--sm@up-to-md">
										{{ joinRequest.status }}
									</p>
								</div>
							</div>
							<p class="c-text c-text--s10 u-hidden@up-to-md">{{ joinRequest.status }}</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-20@md-and-up u-no-p u-ost-md@up-to-md">
							<p class="c-text c-text--right" *ngIf="joinRequest.status === 'PENDING'">
								<span>
									<a id="activateJoinRequestButton" href="javascript:void(0)" class="c-text c-text--uppercase c-text--bold" (click)="vm.activate(joinRequest)">
										{{ 'Employees.Button_Activate' | translate }}
									</a>
								</span>
								<span style="margin-right:5px">&nbsp;</span>
								<span>
									<a id="rejectJoinRequestButton" href="javascript:void(0)" class="c-text c-text--uppercase c-text--bold" (click)="vm.reject(joinRequest)">
										{{ 'Employees.Button_Reject' | translate }}
									</a>
								</span>
							</p>
						</div>
					</div>
				</div>
			</li>
		</ul>
		<item-no-content *ngIf="!vm.joinRequests?.length"></item-no-content>
	</div>
	<loader-overlay *ngIf="vm.loading"></loader-overlay>
</div>
